/* Halloween 2026: prazo que some sozinho à hora limite e profundidade do topo ao mexer o rato.
   Só carrega com o Halloween ligado (layout/theme.liquid). */
(function () {
  // Hora de Lisboa como número AAAAMMDDHHMM, o mesmo formato das datas nas definições do tema
  function agora() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Lisbon', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return +(p.year + p.month + p.day + p.hour + p.minute);
  }

  // Depois da hora limite: tira o prazo (numa página que ficou em cache ou aberta há muito tempo)
  function prazos() {
    var n = agora();
    document.querySelectorAll('[data-vh-hw-ate]').forEach(function (el) {
      if (n >= +el.getAttribute('data-vh-hw-ate')) (el.closest('[data-vh-hw-bloco]') || el).remove();
    });
    document.querySelectorAll('[data-vh-hw-depois][hidden]').forEach(function (el) {
      var bar = el.closest('.vh-hw-bar') || el.parentElement;
      // só quando o prazo com data saiu (na regra de todos os dias o bloco fica e esta mensagem não aparece)
      if (!bar.querySelector('[data-vh-hw-bloco]')) el.hidden = false;
    });
  }
  // Regra de todos os dias ([data-vh-hw-envio], snippets/vh-hw-prazo.liquid): o dia de chegada certo, calculado por
  // window.vhHwEnvio (script logo a seguir à barra do topo, em snippets/shipping-announcement-bar.liquid, para a
  // barra já sair certa no primeiro desenho). Aqui volta a correr para a gaveta, o produto e o carrinho.
  function envio() {
    if (window.vhHwEnvio) window.vhHwEnvio();
  }

  prazos();
  envio();
  setInterval(function () { prazos(); envio(); }, 60000);
  document.addEventListener('shopify:section:load', function () { prazos(); envio(); });
  // a gaveta do carrinho volta a ser desenhada pelo servidor quando muda: acerta o dia outra vez
  var vhHwRaf = 0;
  new MutationObserver(function () {
    if (vhHwRaf) return;
    vhHwRaf = requestAnimationFrame(function () { vhHwRaf = 0; envio(); });
  }).observe(document.body, { childList: true, subtree: true });

  // Profundidade no topo: a lua e os morcegos fogem do rato, os vapes acompanham um pouco
  var palco = document.querySelector('[data-vh-hw-palco]');
  if (!palco) return;
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var hero = palco.closest('.vh-hw-hero') || palco;
  var raf = 0, x = 0, y = 0;
  hero.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    var r = hero.getBoundingClientRect();
    x = (e.clientX - r.left) / r.width - 0.5;
    y = (e.clientY - r.top) / r.height - 0.5;
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      palco.style.setProperty('--px', x.toFixed(3));
      palco.style.setProperty('--py', y.toFixed(3));
    });
  });
  hero.addEventListener('pointerleave', function () {
    palco.style.setProperty('--px', 0);
    palco.style.setProperty('--py', 0);
  });
})();
